var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6114 19.6114L9.88867 9.88864M19.6114 9.88864L9.88867 19.6114",
    stroke: "#f76b5e",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.02728 24.4727C-0.342427 19.103 -0.342427 10.397 5.02728 5.02728C10.397 -0.342427 19.103 -0.342427 24.4727 5.02728C29.8424 10.397 29.8424 19.103 24.4727 24.4727C19.103 29.8424 10.397 29.8424 5.02728 24.4727Z",
    stroke: "#f76b5e",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRound);
export default __webpack_public_path__ + "static/media/closeRound.f06f161f665bfdcdec64c21bc984a85a.svg";
export { ForwardRef as ReactComponent };